import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const BarGraph16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M13.25 1V11.5H14.75V1H13.25Z' fill='currentColor' />
    <path d='M1.25 11.5V8H2.75V11.5H1.25Z' fill='currentColor' />
    <path d='M0 13.25H16V14.75H0V13.25Z' fill='currentColor' />
    <path d='M6.75 3.5V11.5H5.25V3.5H6.75Z' fill='currentColor' />
    <path d='M10.75 11.5V5.5H9.25V11.5H10.75Z' fill='currentColor' />
  </Svg>
);

BarGraph16.displayName = 'BarGraph16';
export default BarGraph16;
